import React, { useContext } from "react";
import { GlobalContext } from "./../Context";
import "./HelpCenter.scss";

export const HelpCenter = () => {
  const globalContext = useContext(GlobalContext);
  const { helpCenterLinks } = globalContext;
  
  // Agregar manejadores de eventos táctiles
  const handleTouchEnd = (e) => {
    e.preventDefault();
    e.target.click();
  };

  return (
    <div className="help-center-container">
      <div className="help-center-container-header">
        <img
          src="/modules/custom/bac_locations/js/src/assets/img/search.svg"
          alt="search"
        />
        <span>Centro de Ayuda</span>
      </div>
      <div className="help-center-description">
        ¡Conozca cómo hacer sus trámites en línea!
      </div>
      <ul className="help-center-list">
        {helpCenterLinks.flatMap((helpCenterLink, i) =>
          helpCenterLink.fieldMultipleLinks.map((link, j) => (
            <li key={`${i}-${j}`}>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={link.path}
                onTouchEnd={handleTouchEnd}
              >
                {link.title}
              </a>
            </li>
          ))
        )}
      </ul>
    </div>
  );
};
